import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { addMonths } from 'date-fns';
// components
import Text from "components/Text";
import { Button } from 'components/Button';
import { Row } from 'components/Layout/Grid';
import { MongoChart } from 'components/MongoChart';
import { BackButton } from '../components/generics/BackButton';
// utils
import { DateOutputStr } from 'utils/DateOutput';
// styles
import { DateFilter, DateLabel } from '../ReportsPage/styles';
import { PageTitle } from '../MapProduct/HeaderMapProduct/styles';
import { useSelector } from 'react-redux';
import { RootState } from 'store/ducks';

export const BIPortal = () => {
  const today = new Date();
  const daysAgo = new Date();
  daysAgo.setDate(today.getDate() - 30);
  const user = useSelector((state: RootState) => state.user);
  const usersAllowedAccessBI = process.env.REACT_APP_USER_ACCESS_BI_PORTAL?.split(",");

  const navigate = useNavigate();

  useEffect(() => {
    if (!usersAllowedAccessBI?.includes(user?.username ?? ""))
      navigate('/cotacoes-dashboard');
  }, [usersAllowedAccessBI]);

  const [startDate, setStartDate] = useState(DateOutputStr(daysAgo.toISOString(), 'yyyy-MM-dd'));
  const [endDate, setEndDate] = useState(DateOutputStr(new Date().toISOString(), 'yyyy-MM-dd'));
  const [refreshChart, setRefreshChart] = useState(false);

  const dashQuotations = useMemo(() => (
    <MongoChart
      endDate={endDate}
      startDate={startDate}
      heightChart="650px"
      refreshChart={refreshChart}
      key="Chart Acompanhamento Cotações"
      dashboardId="80bc9e42-0774-454d-8829-d512cbe09e29"
    />
  ), [refreshChart]);

  const dashDPI = useMemo(() => (
    <MongoChart
      endDate={endDate}
      startDate={startDate}
      refreshChart={refreshChart}
      key="Chart Acompanhamento DPI"
      dashboardId="70177852-6673-476c-8993-8ca78f04a784"
    />
  ), [refreshChart]);

  return (
    <>
      <BackButton />

      <PageTitle size={24} className="color-blue-gray">BI Portal de Cotações</PageTitle>

      <DateFilter>
        <DateLabel>Período</DateLabel>
        <input
          value={startDate}
          onChange={(e) => {
            setStartDate(DateOutputStr(e.target.value, 'yyyy-MM-dd'));
          }}
          type="date"
          max={endDate}
          min={DateOutputStr(addMonths(new Date(), -12).toISOString(), 'yyyy-MM-dd')}
        />
        <DateLabel>a</DateLabel>
        <input
          value={endDate}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setEndDate(DateOutputStr(e.target.value, 'yyyy-MM-dd'));
          }}
          type="date"
          min={startDate}
          max={DateOutputStr(new Date().toISOString(), 'yyyy-MM-dd')}
        />
        <Button
          className={`button bg-cyanLightViveo w-sm-70 w-md-40 w-40 filter-button ml-2`}
          height={40}
          width={85}
          onClick={() => { setRefreshChart(!refreshChart); }}
        >
          <Text
            size={14}
            className="button-text color-primary font-bold"
          >
            Filtrar
          </Text>
        </Button>
      </DateFilter>

      <Row className='mt-3'>
        {dashQuotations}
      </Row>

      <Row className='mt-3'>
        {dashDPI}
      </Row>

      <Row className='mt-3'>
        <iframe
          style={{
            background: "#F1F5F4",
            border: "none",
            boxShadow: "0 2px 10px 0 rgba(70, 76, 79, 0.2)",
            width: "100vw",
            height: "550px",
          }}
          src={"https://charts.mongodb.com/charts-prd---viveo---inovacao-ggrkl/embed/dashboards?id=66ad1b93-db78-4855-8dfd-f05b75ce48fe&theme=light&autoRefresh=true&maxDataAge=3600&showTitleAndDesc=true&scalingWidth=scale&scalingHeight=scale"}
          title="Chart Erros Bionexo"
          allowFullScreen
        />
      </Row>
    </>
  );
};
